import { settings } from '../settings';

export type Handler = {
    id: string;
    name: string;
};


/**
 * Fetches the list of pipeline handlers for the given script (script1–script4).
 * script is sent as a query param; backend returns handlers for that script only.
 */
export async function fetchHandlers(script: string): Promise<Handler[]> {
    if (!script) return [];
    try {
        const url = new URL(`${settings.SERVER_URL}/resources-api/pipeline-editor/get-handlers`);
        url.searchParams.set('script', script);
        const res = await fetch(url.toString());

        if (!res.ok) throw new Error('Failed to fetch handlers');
        return await res.json();

    } catch (error) {
        console.error('Error fetching handlers:', error);
        throw error;
    }
}
